import {useEffect,useRef} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorEnlace(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
    const rutanRef = useRef([]);
  
  let apiData = "";
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "19",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
  const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
  if(parametros.coleccionTodo != "Todo"){
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    const param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      paginaInicio: parametros.pageInicial,
      paginaFin: parametros.pageFin,
      idioma: var_ingles,
      filtrobusqueda: parametros.camposBuscador,
      orderby: parametros.camposOrden,
      orderbyAscDesc: parametros.ordenamiento,
      metodoBusqueda: parametros.metodoBusqueda
    };
    apiData = Api("/app/api/buscadorcore/v1/busquedaEnlaces/", param);
    function RegistraBus(data){
          if(data.length > 0)
            ApiInsertarBusqueda(parametros.textoBusqueda ,"19", data[0].TOTAL, metodo);
          else
            ApiInsertarBusqueda(parametros.textoBusqueda ,"19", 0, metodo);
        }
    useEffect(() => {
      if(parametros.coleccionTodo != "Todo"){
        if (!apiData.loading){
          RegistraBus(apiData.data)
        }
        if(apiData.data.length > 0) {
          let x = 0;
            apiData.data.forEach(element => {
            if (rutanRef.current[element.ID] != null ) {
              document.getElementById("parrafo-Descripcion-" + x).innerHTML=element.DESCRIPCION;
              x++;
            }
          });
          document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
          _updateTotalDatos({totalDatos:apiData.data[0].TOTAL}); 
        }else{
          _updateTotalDatos({totalDatos:0});
        }
      }
    },[apiData.data]);
    return(
        <>
        {apiData.loading? <Modals />:
          !apiData.loading && apiData.data?.map((datos,i) => (
          <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorEnlace-" + i} style={{marginBottom:"56px"}} id={"resultadoGeneral-" + i}>
            <div className="col-xs-12 col-sm-12 " style={{paddingLeft:"0px"}} id={"snippet_row_titulo-" + i}>
              <a target="_blank" href={datos.URL} id={"Titulo-" + i}>
                <span className="goog-trans-section l tit-normal espacios" id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)}>
                  {highlightTexto(datos.TITULO)}
                </span>
              </a>
            </div>
            <div className="col-xs-12 col-lg-10" style={{paddingLeft:"0px"}} id={"nivel1-" + i}>
              <p className="text-justify" id={"snippet_row-tag_p-" + i } style={{paddingTop:"5px", textAlign:"justify"}}>
                {
                  datos.IMAGEN !== ""? <a target="_blank" href={datos.URL} id={"snippet_row-tag_a-" + i}>
                  <img src={datos.IMAGEN} align="left" id={"imagen-" + i} style={{margin:"0px 16px 5px 0px"}} alt=""/>
                  </a>: ""
                }
                <span id={"parrafo-Descripcion-" + i} ref={(el) => (rutanRef.current[i] = el)}>
                </span>
              </p>
            </div>
          </div>
          ))
        }
        </>
      );
  }else{
    let datos=parametros.datos;
    let i= parametros.id;
    let metodo= parametros.metodo;
    useEffect(() => { 
          if (datos.DESCRIPCION !=="")
            document.getElementById("parrafo-Descripcion-" + i).innerHTML=datos.DESCRIPCION;
        }, [datos]);
    return(
      <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorEnlace-" + i} style={{marginBottom:"56px"}} id={"resultadoGeneral-" + i}>
          <div className="col-xs-12 col-sm-12 " style={{paddingLeft:"0px"}} id={"snippet_row_titulo-" + i}>
            <a target="_blank" href={datos.URL} id={"Titulo-" + i}>
              <span className="goog-trans-section l tit-normal espacios" id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, datos.URL, metodo)}>
                {highlightTexto(datos.TITULO)}
              </span>
            </a>
          </div>
          <div className="col-xs-12 col-lg-10" style={{paddingLeft:"0px"}} id={"nivel1-" + i}>
            <p id={"snippet_row-tag_p-" + i } style={{paddingTop:"5px", textAlign:"justify"}}>
              {
                  datos.IMAGEN !== ""? <a target="_blank" href={datos.URL} id={"snippet_row-tag_a-" + i}>
                  <img src={datos.IMAGEN} align="left" id={"imagen-" + i} style={{margin:"0px 16px 5px 0px"}} alt=""/>
                  </a>: ""
              }
              <span id={"parrafo-Descripcion-" + i}>{datos.DESCRIPCION}
              </span>
            </p>
          </div>
      </div>
    );
  }

}
export default BuscadorEnlace;